<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-05-31 14:14:38
 * @FilePath: \YunYin_admin\src\views\Setting\RoleManagement\components\ModifyName.vue
-->
<template>
  <el-dialog
    class="dialog-bg dialog-name"
    title="修改角色名称"
    :visible.sync="dialogNameVisible"
    :before-close="close"
    width="480px"
  >
    <div class="info">
      <el-form :model="ruleForm" ref="ruleForm" label-width="90px">
        <el-form-item label="角色名称">
          <el-input
            v-model="ruleForm.roleName"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input
            type="textarea"
            v-model="ruleForm.roleRemark"
            placeholder="请输入角色描述"
            maxlength="50"
            rows="3"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="handleSaveRoleName">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ModifyName",
  data() {
    return {};
  },
  props: {
    dialogNameVisible: {
      type: Boolean,
      default: () => true,
    },
    ruleForm: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    close() {
      this.$emit("close", "dialogNameVisible");
    },
    /**
     * @descripttion: 修改角色名称
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:19:33
     * @param {*} item 当前数据项
     */
    handleEditRoleName(item) {
      this.ruleForm.id = item.id;
      this.ruleForm.roleName = item.roleName;
      this.ruleForm.roleRemark = item.roleRemark;
      this.dialogNameVisible = true;
    },
    /**
     * @descripttion: 保存修改的名称
     * @Author: juanjuanhui
     * @Date: 2022-01-19 01:19:40
     * @param {*}
     * @return {*}
     */
    handleSaveRoleName() {
      if (!this.ruleForm.roleName) {
        this.$message({
          message: "请输入角色名称",
          type: "warning",
        });
        return;
      }
      this.$http.role
        .updateSRole({ ...this.ruleForm, systemType: this.systemType })
        .then((res) => {
          // this.getRoleList();
          if (res.status == 1) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.close();
            this.$emit("getRoleList");
          }
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.dialog-name {
  .el-dialog__body {
    padding: 20px 40px;
  }
}
</style>

